import { twMerge } from 'tailwind-merge';
import { Button } from 'structure/home/components/Button';
import { cva, VariantProps } from 'class-variance-authority';

interface BubbleButtonProps extends VariantProps<typeof bubbleButtonStyles> {
  children: React.ReactNode;
  onClick?: () => void;
}

const bubbleButtonStyles = cva(
  twMerge(
    `text-nowrap rounded-full border px-3 py-[6px] text-sm`,
    'ngmd:text-[20px]',
    'nglg:px-9 nglg:py-4 nglg:font-medium',
    'ngxl:text-[24px]'
  ),
  {
    variants: {
      active: {
        true: '[background:linear-gradient(69.35deg,_#144E41_0.07%,_#111111_100.07%)] text-softYellow !border-softYellow',
        false: 'bg-transparent text-[#FFFFFF] border-[#ffffff]',
      },
    },
    defaultVariants: {
      active: false,
    },
  }
);

export const BubbleButton = (props: BubbleButtonProps) => {
  const { active, onClick, children } = props;
  const classNames = twMerge(bubbleButtonStyles({ active }));

  return (
    <Button style='unspecified' onClick={onClick} className={classNames}>
      {children}
    </Button>
  );
};
